module.exports = __webpack_public_path__ + "static/files/acv_sickParent.20846b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/acv_sickParent.png
// module id = KI2E
// module chunks = 0